module.exports = __webpack_public_path__ + "static/media/fondo-login.32d68d30.png";